import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Skeleton,
} from '@mui/material';

type IProps = {
  isOpen: boolean;
};

export const DocumentPortalAccordionSkeleton = ({ isOpen }: IProps) => {
  return (
    <Accordion variant='outlined' expanded={isOpen}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Box sx={{ width: '33%', flexShrink: 0 }}>
          <Skeleton variant='text' width='80%' />
        </Box>
        <Box sx={{ color: 'text.secondary' }}>
          <Skeleton variant='text' width={150} />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell sx={{ flex: 1 }}>
                <Skeleton variant='text' />
              </TableCell>
              <TableCell sx={{ width: 100 }}>
                <Skeleton variant='text' />
              </TableCell>
              <TableCell sx={{ width: 200 }}>
                <Skeleton variant='text' />
              </TableCell>
              <TableCell sx={{ width: 200 }}>
                <Skeleton variant='text' />
              </TableCell>
              <TableCell sx={{ flex: 1 }}>
                <Skeleton variant='text' />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(3)].map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Skeleton variant='text' />
                </TableCell>
                <TableCell>
                  <Skeleton variant='text' />
                </TableCell>
                <TableCell>
                  <Skeleton variant='text' />
                </TableCell>
                <TableCell>
                  <Skeleton variant='text' />
                </TableCell>
                <TableCell>
                  <Skeleton variant='text' />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
};
